export default {
  downtimeUrl: "https://mrqz.me/6204623711474a003fb42b0f",
  startPage: {
    image: "/welcome/quiz_project_girl.jpeg",
    title: "<div>Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda</div>",
    subtitle:
      "Di kelas, kami akan memberitahu bagaimana cara mempersiapkan anak untuk profesi berpenghasilan tinggi dan banyak dicari!",
    button: "Tekan untuk melanjutkan!🚀",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah anak Anda tertarik dalam desain, kartun dan animasi?",
      answers: [
        "💯 Ya, sangat tertarik",
        "🤓 Tidak tertarik",
        "🤔 Kami tidak pernah membicarakannya",
      ],
    },
    2: {
      question:
        "Apakah Anda ingin anak Anda mendapatkan profesi berpenghasilan tinggi dan banyak dicari?",
      answers: ["😍 Ya, tentu", "🙂 Tidak"],
    },
    3: {
      question:
        "Menurut Anda, berapa rata-rata pendapatan dari seorang pembuat kartun dan animasi?",
      answers: ["900,000,000 IDR", "1,000,000,000 IDR", "500,000,000 IDR", "700,000,000 IDR"],
    },
  },
};
